import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { baseUrl } from '../../constants';

@Injectable({ providedIn: 'root' })
export class SupplyService {
  constructor(private http: HttpClient) {}

  private get headers() {
    const token = localStorage.getItem('token');
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      })
    };
  }

  getProducts(): Observable<any[]> {
    return this.http.get<any[]>(`${baseUrl}SupplyProducts`, this.headers);
  }

  createProductType(payload: { name: string }): Observable<any> {
    return this.http.post(`${baseUrl}SupplyProducts/types`, payload, this.headers);
  }

  updateProductType(id: number, payload: { name: string }): Observable<any> {
    return this.http.put(`${baseUrl}SupplyProducts/types/${id}`, payload, this.headers);
  }

  deleteProductType(id: number): Observable<any> {
    return this.http.delete(`${baseUrl}SupplyProducts/types/${id}`, this.headers);
  }

  createProductItem(payload: { productTypeId: number; name: string; currentStock?: number; reorderLevel?: number; unitLabel?: string | null }): Observable<any> {
    return this.http.post(`${baseUrl}SupplyProducts/items`, payload, this.headers);
  }

  updateProductItem(id: number, payload: { name: string; currentStock?: number; reorderLevel?: number; unitLabel?: string | null }): Observable<any> {
    return this.http.put(`${baseUrl}SupplyProducts/items/${id}`, payload, this.headers);
  }

  deleteProductItem(id: number): Observable<any> {
    return this.http.delete(`${baseUrl}SupplyProducts/items/${id}`, this.headers);
  }

  getDispatches(filters?: {
    from?: string;
    to?: string;
    productTypeId?: number | null;
    productItemId?: number | null;
    search?: string;
  }): Observable<any[]> {
    let params = new HttpParams();
    if (filters?.from) params = params.set('from', filters.from);
    if (filters?.to) params = params.set('to', filters.to);
    if (filters?.productTypeId) params = params.set('productTypeId', String(filters.productTypeId));
    if (filters?.productItemId) params = params.set('productItemId', String(filters.productItemId));
    if (filters?.search) params = params.set('search', filters.search);

    return this.http.get<any[]>(`${baseUrl}SupplyDispatch`, { ...this.headers, params });
  }

  createDispatch(payload: any): Observable<any> {
    return this.http.post(`${baseUrl}SupplyDispatch`, payload, this.headers);
  }

  updateDispatch(id: number, payload: any): Observable<any> {
    return this.http.put(`${baseUrl}SupplyDispatch/${id}`, payload, this.headers);
  }

  deleteDispatch(id: number): Observable<any> {
    return this.http.delete(`${baseUrl}SupplyDispatch/${id}`, this.headers);
  }

  getDispatchAnalytics(filters?: {
    from?: string;
    to?: string;
    productTypeId?: number | null;
    productItemId?: number | null;
  }): Observable<any> {
    let params = new HttpParams();
    if (filters?.from) params = params.set('from', filters.from);
    if (filters?.to) params = params.set('to', filters.to);
    if (filters?.productTypeId) params = params.set('productTypeId', String(filters.productTypeId));
    if (filters?.productItemId) params = params.set('productItemId', String(filters.productItemId));

    return this.http.get<any>(`${baseUrl}SupplyDispatch/analytics`, { ...this.headers, params });
  }
}
